import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';

import { RelatedContentDataSource } from '../../services/related-content-data-source';
import { RelatedContentApiService } from '../../services/related-content-api-service';
import { CarouselImageDataSource } from 'src/modules/carousel-image/services/carousel-image-data-source';

@Component({
    selector: 'related-content-add-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class RelatedContentAdd implements OnInit {
  public form: FormGroup;
  public loading: boolean;
  private dataSource: RelatedContentDataSource;
  public relatedContentId;
  public listingId;

  constructor(
    private dialog: MatDialog,
    protected dialogRef: MatDialogRef<RelatedContentAdd>,
    protected service: RelatedContentApiService,
    @Inject(MAT_DIALOG_DATA) public DataSource: CarouselImageDataSource,
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private fb: FormBuilder
  ) {
    this.listingId = data.listingId;
  }

  ngOnInit() {
    this.dataSource = this.data.dataSource;
    this.form = this.fb.group({
      related_listing_id: [null, [Validators.required]],
  
    });
  }

  onSubmit() {
    const relatedContent = this.form.getRawValue();
    relatedContent.listingId = this.listingId;
    this.form.disable();
    this.dataSource.save(relatedContent).then(
      (data) => {
        this.dialogRef.close();
      },
      (error) => this.form.enable()
    );
  }

}
